<template>
    <div class="flex-column" v-if="action_local">
        <div class="flexRow window-text">
            <p>Window Text</p>
            <textarea v-model="windowText" @blur="onUpdate(action, 'configuration')"></textarea>
            <TranslatedText v-if="languages && languages.length > 1" :textJson="action_local.configuration.windowTextJson"
                    position="bottom" alignment="start" :defaultLanguage="defaultLanguage"></TranslatedText>
        </div>
        <p>Buttons:</p>
        <VueDraggableNext class="dragArea list-group w-full" :list="action_local.configuration.buttons" @update="moveButton" >
            <div v-for="(but, ind) in action_local.configuration.buttons" :key="but.sequence" class="row">
                <div class="grip">
                    <i class="fa-solid fa-grip-vertical"></i>
                </div>
                <div class="flexColumn">
                    <label>Button Text</label>
                    <input type="text" v-model="but.text" @blur="updateButtonText(but)"/>
                    <TranslatedText v-if="languages && languages.length > 1" :textJson="but.textJson"
                        position="bottom" alignment="start" :defaultLanguage="defaultLanguage"></TranslatedText>
                    <template v-if="but.type === 'Anchor'">
                        <label>Link URL</label>
                        <input type="text" v-model="but.linkUrl" @blur="onUpdate(action, 'configuration')" />
                    </template>
                </div>
                <div class="flexColumn">
                    <label>Type</label>
                    <select v-model="but.type" @change="onUpdate(action, 'configuration')">
                        <option v-for="type in buttonTypes" :key="type.internalName" :value="type.internalName">{{ type.displayName }}</option>
                    </select>
                </div>
                <div class="delete-button-column">
                    <div  @click="deleteButton(ind)" :style="allowEdit ? '' : 'display: none'">
                        <i class="fas fa-lg fa-trash-can"></i>
                    </div>
                </div>
            </div>
        </VueDraggableNext>
        <button @click="addButton" class="add-button"><i class="fa-circle-plus fas fa-2xl"></i></button>
        <h2>Audio</h2>
        <div @click="showAddMediaPropertyModal = true"  :style="allowEdit ? '' : 'display: none;'" class="openModalButton" style="color: #036991; cursor: pointer;margin-left: 20px;">
            <i class="fa-circle-plus fas fa-2xl"></i>
        </div>
        <AddAudioActionModal v-if="showAddMediaPropertyModal" @saveMediaProperty="saveNewAudio" @hideAddMediaPropertyModal="showAddMediaPropertyModal = false" :object="action_local" mediaTypeFilter="Audio"></AddAudioActionModal>
        <VueDraggableNext class="dragArea list-group w-full" style="padding: 0px; width:100%;" :list="audioMediaProperties" @update="moveAction" v-if="audioMediaProperties.length > 0">
            <div class="row row-data" v-for="(mediaProperty, mpIndex) in audioMediaProperties" :key="mpIndex">
                <div class="grip">
                    <i class="fa-solid fa-grip-vertical"></i>
                </div>
                <div class="column-2x">
                    <a :href="'/MediaPropertyEdit?ID=' + mediaProperty.id">
                        {{ mediaProperty.description }}&nbsp;&nbsp; 
                    <i class="fa-solid fa-arrow-up-right-from-square" style="color:#036991;"></i></a>              
                </div>
                <div class="deleteButtonColumn">
                    <div  @click="deleteAudio (mediaProperty)" :style="allowEdit ? '' : 'display: none'">
                        <i class="fas fa-lg fa-trash-can"></i>
                    </div>
                </div>
            </div>
        </VueDraggableNext>
    </div>
</template>

<script>
import { VueDraggableNext} from 'vue-draggable-next';
import TranslatedText from '@/components/shared/TranslatedText.vue';
import { translation } from '@/shared/translation';
import { data } from '@/shared/data';
import AddAudioActionModal from '@/components/mediaproperty/AddAudioActionModal.vue';

export default {
    name: 'ButtonModalConfiguration',
    components: { VueDraggableNext, TranslatedText, AddAudioActionModal },
    data() {
        return {
            action_local: null,
            buttonTypes: null,
            showAddMediaPropertyModal: false,
            audioMediaProperties: []
        }
    },
    props: {
        allowEdit: {
            type: Boolean,
            required: true
        },
        action: {
            type: Object,
            default: null
        },
        onUpdate: {
            type: Function,
            default: null,
            required: true
        },
        languages: {
            type: Array,
            default: () => ["English"]
        },
        defaultLanguage: {
            type: String,
            default: "English"
        }
    },
    async mounted() {
        this.buttonTypes = await data.getEnumList('ButtonTypes', false);
        this.action_local = this.action;
        this.sortButtons(this.action_local.configuration.buttons);
        this.action_local.configuration.buttons.forEach(but => {
            but.text = translation.getTextForLanguage(but.textJson, this.defaultLanguage);
        })
        if(this.action_local.configuration.audioMediaPropertyIDs?.length > 0)
            await this.updateAudioListing();
    },
    computed: {
        windowText: {
            get() {
                return translation.getTextForLanguage(this.action.configuration.windowTextJson, this.defaultLanguage);
            },
            set(newText) {
                translation.setTextForLanguage(this.action.configuration, this.defaultLanguage, 'windowTextJson', newText);
            }
        },
    },
    methods: {
        sortButtons: function(buttons) {
            buttons.sort((a,b) => {
                return a.sequence - b.sequence;
            });
        },
        moveButton: function(evt) {
            if(evt) {
                let buttons = this.action_local.configuration.buttons;
                for(var i = 0; i < buttons.length; i++) {
                    if(buttons[i].sequence != i+1)
                    {
                        buttons[i].sequence = i+1;
                    }
                    else if(i > (evt.oldIndex + 1) && i > (evt.newIndex + 1)) 
                    //once we get here we know we don't have to reorder anything anymore. 
                        break;
                } 
                this.sortButtons(buttons);
                this.onUpdate(this.action_local, 'configuration');
            }
        },
        deleteButton: async function(buttonInd) {
            if(confirm('Are you sure you want to delete this button?')) {
                this.action_local.configuration.buttons.splice(buttonInd, 1);
                for(let i = 0; i < this.action_local.configuration.buttons.length; i++) {
                    if(i >= buttonInd)
                        this.action_local.configuration.buttons[i].sequence--;
                }
                this.onUpdate(this.action_local, 'configuration');
            }
        },
        addButton: function() {
            this.action_local.configuration.buttons.push({
                text: '',
                textJson: [],
                sequence: this.action_local.configuration.buttons.length + 1
            });
        },
        updateButtonText: async function(button) {
            button.textJson = await translation.addTranslations(button.textJson, button.text, this.languages, this.defaultLanguage);
            this.onUpdate(this.action, 'configuration');
        },
        saveNewAudio: async function(mp) {
            this.action_local.configuration.audioMediaPropertyIDs.push(mp.id);
            this.onUpdate(this.action, 'configuration');
            await this.updateAudioListing();
        },
        deleteAudio: async function(mp) {
            const ind = this.action_local.configuration.audioMediaPropertyIDs.indexOf(mp.id);
            if(ind >= 0)
                this.action_local.configuration.audioMediaPropertyIDs.splice(ind,1);
            this.onUpdate(this.action, 'configuration');
            await this.updateAudioListing();
        },
        updateAudioListing: async function() {
            let audioMediaProperties = [];
            for(let i = 0; i < this.action_local.configuration.audioMediaPropertyIDs.length; i++) {
                audioMediaProperties.push(await data.getMediaProperty(this.action_local.configuration.audioMediaPropertyIDs[i]));
            }
            this.audioMediaProperties = audioMediaProperties;
        }
    }
}
</script>

<style scoped>
    .window-text textarea {
        margin-left: 2em;
        width: 30em;
        height: 5em;
    }
    .row {
        display: flex;
        flex-direction: row;
        width: fit-content;
        align-items: center;
        border-bottom: 1px solid black;
        padding: 2em 0;
    }
    .row:nth-child(odd) {
        background-color: #ffffff;
    }
    .row > div {
        margin-right: 2em;
    } 
    .row .grip {
        cursor:grab;
    }
    .delete-button-column {
        color: darkred;
    }
    .add-button {
        background-color: unset;
        border: none;
        cursor: pointer;
        font-size: 16px;
        color:#036991;
        margin: 1em 0 0 5em;
    }
    .flexColumn input {
        margin-bottom: 1em;
    }
</style>